class DateUtils {

    toStartOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    plusMonths(date, months) {
        let newDate = new Date(date.getTime());
        newDate.setMonth(date.getMonth() + months);
        return newDate;
    }

    ISOdateStringToDate(dateIsoString) {
        const [year, month, day] = dateIsoString.substr(0, 10).split('-').map(str => parseInt(str, 10));

        let date = new Date();
        date.setFullYear(year);
        date.setMonth(month - 1);
        date.setDate(day);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }

    toLocalISOdate(date) {
        return date.getFullYear() + '-' + this._zeroPadd(date.getMonth() + 1) + '-' + this._zeroPadd(date.getDate());
    }

    _zeroPadd(number) {
        let val = '' + number;
        if (val.length < 2) {
            val = '0' + val;
        }
        return val;
    }
}

export default new DateUtils();
